import type { ReactNode } from 'react';
import { Children, useMemo } from 'react';

import { LegacyTooltip } from '#/components/LegacyTooltip/LegacyTooltip';
import { HeadingSmall } from '#/components/Text/HeadingSmall';

import {
  DetailsListGroupHeader,
  DetailsListGroupHolder,
  DetailsListGroupItems,
  DetailsListGroupTooltip,
} from './DetailsListGroup.styled';

type Props = {
  title: ReactNode;
  children: ReactNode;
  tooltipText?: ReactNode;
  qaId?: string;
};

export function DetailsListGroup({
  title,
  children,
  tooltipText,
  qaId,
}: Props) {
  const isEmpty = useMemo(() => {
    const truthyChildren = Children.toArray(children).filter(Boolean);
    return truthyChildren.filter(Boolean).length === 0;
  }, [children]);

  if (isEmpty) return null;

  return (
    <DetailsListGroupHolder data-qa-id={qaId}>
      <DetailsListGroupHeader>
        <HeadingSmall mb={0}>{title}</HeadingSmall>

        {tooltipText && (
          <DetailsListGroupTooltip>
            <LegacyTooltip greyColor>{tooltipText}</LegacyTooltip>
          </DetailsListGroupTooltip>
        )}
      </DetailsListGroupHeader>

      <DetailsListGroupItems>{children}</DetailsListGroupItems>
    </DetailsListGroupHolder>
  );
}
